<template>
  <div class="notif-body">
    <div class="wording">
      <span class="notif-link" @click="goToUserInfo">{{ notif.payload.jsoncontent.user.firstName }} {{ notif.payload.jsoncontent.user.lastName }}</span>
      <span> {{ $t('notification.notifJoinRequest.hasRequestedToJoinYourCommunity') }} </span>
      <span class="notif-link" @click="goToCommunity">{{ notif.payload.jsoncontent.CommunityName }}</span>
    </div>
    <div>
      <div v-if="notif.action === 'none'" class="btn-container">
        <v-button class="btn" :type="'secondary'" :on-click="decline" :font-size="'13x'" :height="'32px'">
          {{ $t('notification.notifJoinRequest.decline') }}
        </v-button>
        <v-button class="btn" :on-click="approve" :font-size="'13x'" :height="'32px'">
          {{ $t('notification.notifJoinRequest.validate') }}
        </v-button>
      </div>
      <div v-if="notif.action === 'approved'" class="btn-container">
        <button class="btn button-disabled" :disabled="true">
          {{ $t('notification.notifJoinRequest.validated') }}
        </button>
      </div>
      <div v-if="notif.action === 'declined'" class="btn-container">
        <button class="btn button-disabled" :disabled="true">
          {{ $t('notification.notifJoinRequest.declined') }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import VButton from '@/components/shared/VButton'

export default {
  name: 'NotifJoinRequest',
  components: { VButton },
  props: {
    notif: {
      type: Object,
      required: true
    }
  },
  methods: {
    goToUserInfo () {
      this.$store.dispatch('showHidePanel', 'NOTIF')
      this.$store.dispatch('markNotificationIsRead', this.notif.id)
      this.$router.push({ name: 'userInfo', params: { id: this.notif.payload.jsoncontent.user.id } })
    },
    goToCommunity () {
      this.$store.dispatch('showHidePanel', 'NOTIF')
      this.$store.dispatch('markNotificationIsRead', this.notif.id)
      this.$router.push({ name: 'communityPage', params: { id: this.notif.payload.jsoncontent.idCommunity } })
    },
    approve (joinRequest) {
      this.$store.dispatch('approveJoinRequest', {
        idCommunity: this.notif.payload.jsoncontent.idCommunity,
        idUser: this.notif.payload.jsoncontent.user.id,
        id: this.notif.payload.jsoncontent.idJoinRequest }
      )
      this.$store.commit('approveNotif', this.notif.id)
      this.$store.dispatch('markNotificationIsRead', this.notif.id)
    },
    decline (joinRequest) {
      this.$store.dispatch('declineJoinRequest', {
        idCommunity: this.notif.payload.jsoncontent.idCommunity,
        idUser: this.notif.payload.jsoncontent.user.id,
        id: this.notif.payload.jsoncontent.idJoinRequest
      })
      this.$store.commit('declineNotif', this.notif.id)
      this.$store.dispatch('markNotificationIsRead', this.notif.id)
    },
    truncateText (str) {
      if (str.length > 50) {
        return str.substring(0, 47) + '...'
      } else {
        return str
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.btn-container {
  display:flex;
  flex-direction: row;
  justify-content: flex-start;
  margin-top: 8px;
  .btn {
    margin: 2px 10px 2px 0;
  }
}

.button-disabled {
    height: 32px;
    border-radius: 3px;
    padding: 0 12px;
    font-size: 13px;
    letter-spacing: 0;
    text-align: center;
    background:#9B9B9B;
    color: #FFFFFF;
    cursor: default;
    border: none;
}

</style>
<style lang="scss" src="./NotifStyle.scss" scoped></style>
